// Rhythm inhouse Dropdown plugin
//Release 18.2.0
/* start-amd-strip-block */
(function(factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module
    define(['jquery'], factory);
  } else if (typeof exports === 'object') {
    // Node/CommonJS
    module.exports = factory(require('jquery'));
  } else {
    // Browser globals
    factory(jQuery);
  }
}(function($) {
  /* end-amd-strip-block */

  $.fn.droppy = function(options) {
    'use strict';
    // Settings and Options
    var pluginName = 'droppy',
    defaults = {
      closeOnSelect: false, // When an option is selected, the list will close if set to "true".  List stays open if "false".
      maxSelected: undefined, // If in multiple mode, sets a limit on the number of options that can be selected. Can be set using the max="" attribute on the input field as well.
      multiple: true, // Turns the droppy into a multiple selection box
      noSearch: false, // If true, disables the ability of the user to enter text in the Search Input field in the open droppy.
      extendListWidth: true, // If true, calculate and extend the width of the dropdown list to fully show the content.
      highWidthPadding: 20 // Extra padding on the largest width check
    },
    settings = $.extend({}, defaults, options);

    // Plugin Constructor
    function Droppy(element) {
      this.settings = $.extend({}, settings);
      this.element = $(element);
      this.init();
    }

    // Plugin Methods
    Droppy.prototype = {
      civicsBuildBodyList:function(list){
        if(this.inScrollableGrid){
         //the DDL is inside a scrollable grid. Copy the list into a body-level container and return.
         var $dropdownLists = $(this.civicsGetDropdowns());
         $dropdownLists.append(list);
       }
       return list;
     },

     civicsCloseList: function(){
       if(!this.preventAutoClose){
         this.scrollingDiv.off('scroll.dropdown'+this.input.name);
         this.closeList();
       }else {
         //if the list just opened, but we're seeing a scroll event we need to position the drop down appropriately.
         this.civicsSetPosition();
       }
     },

     civicsGetDropdowns:function(){
       //First, check to see if the drop down lists container exists. If it doesn't, create it. This is used to contain all DDLs in scrollable divs.
       var $ddlsContainer = $('body').find('#dropdownLists .rhy');
       if($ddlsContainer.length!=1){
         var $wrapper1 = $('<div>').attr('id','dropdownLists');
         $ddlsContainer = $('<div>').addClass('rhy');
         $wrapper1.append($ddlsContainer);
         $('body').append($wrapper1);
       }
       //now, look for the specific div that contains our list. There may be several lists in $ddlsContainer. If it doesn't exist, create it.
       var $listContainer = $ddlsContainer.find('.'+this.input.attr('id')+'-dropdown-container');
       if($listContainer.length!=1){
         $listContainer = $('<div>').addClass('droppy ' + this.input.attr('id')+'-dropdown-container').css({position:'inherit'});
         $ddlsContainer.append($listContainer);
       }
       return $listContainer;
     },

     civicsOpenList:function(){
       this.civicsUpdateOptions();
       if(this.settings.widgetPositioning && this.settings.widgetPositioning.vertical==='top') {
         var width = this.input.outerWidth();
         var height = this.input.outerHeight();
         var listHeight = this.list.outerHeight();
         var elementHeight = this.element.outerHeight();
         this.list.css({
           position:'relative',
           top:(0-height-listHeight+1),
           left:0,
           width:width
         });
         this.element.css({
           height: elementHeight //fix the element's height so it doesn't expand for the list div
         });
         this.input.addClass('input-top-widget');
       }
       if(this.inScrollableGrid){
         this.list = this.civicsBuildBodyList(this.list);
         this.civicsSetPosition();
         this.scrollingDiv = this.element.closest('.overflowing').length == 1 ? this.element.closest('.overflowing') : this.element.closest('.bbm-modal');
         this.preventAutoClose = true;

         //we need to capture the position change done when the drop down is off screen. This change may not cause a scroll event, so
         //we'll force position updates for a few ms
         var positionTimer = setInterval(function(){
           this.civicsSetPosition();
         }.bind(this),10);

         //if a drop down is partially off screen, and opened, it scrolls into view, which may trigger the close on scroll function.
         //we set a timer here to prevent erroneous closing
         setTimeout(function(){
           clearInterval(positionTimer);
           this.preventAutoClose = false;
         }.bind(this),250);

         this.scrollingDiv.on('scroll.dropdown'+this.input.name, this.civicsCloseList.bind(this));
       }
     },

     //check to see if the options stored in memory match the options in the dom. When a droppy is updated dynamically, the in-memory list needs to be updated.
     civicsOptionsChanged:function(optionValuesFromServer){
       var currentOptions = this.options;
       var newOptions = (optionValuesFromServer && optionValuesFromServer.length) ? optionValuesFromServer : this.list.find('.droppy-option');
       var changed = false;

       if(_.isEmpty(currentOptions) || newOptions.length!=currentOptions.length){
         changed = true;
       } else {
         for(var i=0; i<newOptions.length; i++){
           let option = (optionValuesFromServer && optionValuesFromServer.length) ? newOptions[i] :newOptions[i].dataset.val;
            if(option != currentOptions[i].dataset.val){
             changed = true;
             break;
           }
         }
       }
       return changed;
     },

     civicsSetPosition:function(){
       var offset;
       var width;

       //Checks if the dropdown in use has detail page ancestor
       var detailPageDroppy = $('#' + this.input.attr('id')).closest('.modal-detail-el').length;

       if (detailPageDroppy > 0 ) {
         offset = this.input.offset();
         width = this.input.outerWidth();
       } else {
         offset = this.input.position();
       }

       var height = this.input.outerHeight();

       if(this.list.hasClass("openUp")) {
         height = -(this.list.innerHeight() + 1);
       }

       this.list.css({
         position:'absolute',
         top:offset.top+height+1,
         left:offset.left,
         width:width
       });
     },

     civicsUpdateOptions:function(skipOptionCheck=false){
       if(this.civicsOptionsChanged() || skipOptionCheck) {
         this.options = this.list.find('.droppy-option');
         this.optionCount = this.options.length;
         var foundOption = null;

         this.selectedOptions = [];
         //views that update a droppy can use the data-currentSelection attribute to store a value to be re-selected after the drop down is re-populated.
         //the value of the attribute is compared to the newly loaded options and if a match is found, that option is selected.
         if(!_.isEmpty(this.input.data('currentSelection'))){
           var currSelection = this.input.data('currentSelection');
           for(var i=0; i<this.options.length; i++){
             if(this.options[i].dataset.val == currSelection){
               foundOption = this.options[i];
               this.options[i].setAttribute('aria-selected','true');
               break;
             }
           }
         }

         if(foundOption!==null){
           this.selectedOptions = {
             content: $(foundOption).find('.option-content').text(),
             data: $(foundOption).attr('data-val'),
             icon: $(foundOption).find('.icon').attr('class'),
             iconHref: $(foundOption).find('use').attr('xlink:href')
           };
           this.setInputVal(this.selectedOptions.content);
         }
         //clear out any existing current selection.
         this.input.data('currentSelection','');

         var originalContent = [];
         this.options.each(function() {
           originalContent.push($(this).find('.option-content').text());
         });
         this.optionsContent = originalContent;

         if(this.settings.multiple) { // Add extra element specific to multi-select state.
           if(this.multiSelectInitiated === false){
             this.list.prepend('<li class="group-label group-all">All</li>');
             this.list.prepend('<li class="group-label group-selected">Selected</li>');
           }
           //remove existing checkboxes
           this.find('multi-select-checkbox').remove();
           this.options.each(function(i) {
             //add checkboxes
             $(this).prepend('<div class="field multi-select-checkbox">'+
             '<input role="presentation" tabindex="-1" class="input-checkbox" type="checkbox"/>'+
             '<label></label>'+
             '</div>');
           });
         }

        this.setDroppyWidth(true);
       }
     },
     //note that the below function exists in the droppy.js plugin in the civics theme as well.
     civicsToggleLoading:function(enabled,args){
       if(enabled == null){
         return;
       }
       let loadingText = args ? args.loadingText ? args.loadingText : '' : '';
       if(!enabled){
         this.element.find('.field-loader').remove();
       } else {
         this.element.find('input').before(
           '<div class="field-loader"><span class="scr">' + loadingText + '</span></div>');
       }
     },
     /**
      * This function dynamically updates the li inside the droppy-list element
      * @param {array} newOptions - array of codes to be compared in the this.options for us to determine if a change in list options occur
      * @param {array} listElements  - array of list elements to be append in the droppy-list.
      * @param {string} selectedValue - current selected value for the droppy input.
      */
     civicsRebuildDroppyList: function(newOptions, $droppyList, listElements, selectedValue, isAcceptEmptyNewList){

       if (isAcceptEmptyNewList || ((newOptions && newOptions.length > 0) && this.civicsOptionsChanged(newOptions))) {
         //reset input.
         $droppyList.empty();
         this.setInputVal('');

         listElements.forEach((val, index) => {
           $droppyList.append(val);
         });

         if (selectedValue) {
           this.setInputVal(selectedValue, $droppyList);
         }

         this.civicsUpdateOptions(true);
       }

     },
      init: function() {
        var self = this;
        this.toggleBtn = this.element.find('.droppy-toggle');
        this.input = this.element.find('.droppy-input');
        this.inScrollableGrid =  this.input.attr('specialtype') === 'grid' || this.input.attr('specialtype') === 'modalDdl';
        this.preventAutoClose = false;
        // Track if focus arrived via Shift+Tab to prevent auto-expand
        this._shiftTabbing = false;
        this.label = this.element.find('.input-label');
        this.settings.maxSelected = this.input.attr('max');
        this.list = this.element.find('.droppy-list');
        this.list.scrollLock();
        this.searchState = "off"; // Global toggle that will be used to set current state.

        this.options = this.element.find('.droppy-option');
        this.optionCount = 0;
        var originalContent = [];
        this.options.each(function() {
          originalContent.push($(this).find('.option-content').text());
        });
        this.optionsContent = originalContent;

        this.multiSelectInitiated = false;
        this.civicsUpdateOptions();
        this.selectedOptions = [];
        this.multiList = [];

        this.input.attr('aria-expanded', 'false');

        // Ensure all options have aria-selected="false" by default
        this.options.attr('aria-selected', 'false');

        if(this.settings.multiple) { // Add extra element specific to multi-select state.
          this.list.prepend('<li class="group-label group-all">All</li>');
          this.list.prepend('<li class="group-label group-selected">Selected</li>');

          this.options.each(function(i) {
            $(this).prepend('<div class="field">'+
            '<input role="presentation" tabindex="-1" class="input-checkbox" type="checkbox"/>'+
            '<label></label>'+
            '</div>');
          });
        }

        // If ID is missing on the list element, add it and the aria attributes
        let ddlistId = this.list.attr("id");
        if(!(typeof ddlistId !== 'undefined' && ddlistId !== false)) {
          ddlistId = this.input.attr("id") + "list";
          this.input.attr("aria-controls", ddlistId);
          this.input.attr("aria-owns", ddlistId);
          this.list.attr("id", ddlistId);
        }

        if(!this.settings.noSearch) {
          // Finding the screen reader element to read the amount of results
          this.searchResult = this.element.find('.live-region-list-count');
          this.searchResultText = this.searchResult.data("text");
        }

        $(document).on('click', function(e) {
          var target = $(e.target); // Clicktarget
          if(!self.isDroppyElement(target)) {
            // Click is not inside the droppy element
            self.closeList();
          }
          else if(!self.element.hasClass('disabled')) {
            if(target.is(self.toggleBtn)) { // If clicking the arrow button
              self.toggleBtnClick();
              e.preventDefault(); // Prevents event being triggered for input click.
              return;
            }
            if(target.is(self.label)) { // If clicking the arrow button
              e.preventDefault();
              self.inputClick();
              return;
            }
            if(target.is(self.input)) { // If clicking the input field
              self.inputClick();
              return;
            }
            if(target.is(self.list.find('.droppy-option')) || target.is(self.list.find('.droppy-option *'))) { // If clicking a list option
              var element;
              if(!target.is(self.list.find('.droppy-option'))) {
                element = target.closest('.droppy-option');
              }
              else {
                element = target;
              }
              self.listClick(element);
              return;
            }
          }
        });

        if(!this.settings.noSearch && !this.isOpen()) {
          this.input.on('touchstart', function() { // Touchstart is fired prior to click and enables keyboard in mobile devices.
            // self.input.prop('readonly', '');
          });
          this.toggleBtn.on('touchstart', function() {
            // self.input.prop('readonly', '');
          });
          this.label.on('touchstart', function() {
            // self.input.prop('readonly', '');
          });
        }

        this.element.on('keydown', function(e) {
          self.handleKeydown(e)
        });
        this.element.on('keyup', function(e) {
          self.handleKeyup(e)
        });

        this.element.on('droppyChange', function(e) {
          var $input = $(e.target);
          var isRequired = $input.find('input').first().attr('required');
          if(isRequired && ((self.selectedOptions.data  && self.selectedOptions.data != '') || (self.multiList && self.multiList.length > 0))){
            self.clearError($input);
          }
          if(self.settings.multiple) {
            return self.multiList;
          }
          else {
            return self.selectedOptions;
          }
        });

        var preselected = this.element.find('.pre-selected');
        preselected.each(function() {
          self.selectOption($(this), true);
        });

        // note that the below event listeners exist in the droppy.js plugin in the civics theme as well.
        this.input.on('setLoading', ()=>{this.civicsToggleLoading(true)});
        this.input.on('removeLoading', ()=>{this.civicsToggleLoading(false)});
        this.input.on('rebuildDroppyList', (e, newOptions, $droppyList, listElements, selectedValue, isAcceptEmptyNewList)=>{this.civicsRebuildDroppyList(newOptions, $droppyList, listElements, selectedValue, isAcceptEmptyNewList===true)});
      },
      //-------------------------------------------------- init function end -----------------------------------------------

      searchMode: function(mode, str, isClosing) {
        // mode === true searches the list options with a string fetched from the input field if str parameter is undefined.
        // If str is specified this will serve as searchTerm, can be used to reset the current search, by adding empty string.
        // Searchmode is called on keyup event.
        // Mode true or false is toggeling the global this.searchState wich is used to check the current state in other functions.
        var searchTerm;
        if(str === undefined) {
          searchTerm = this.input.val().toLowerCase();
        }
        else {
          searchTerm = str;
        }
        if(mode === true) {
          this.searchState = "on";
          this.deactivateOption();
          this.toggleBtn.find('.icon').attr('class', 'icon search');
          this.toggleBtn.find('.icon use').attr('xlink:href', '#search');
          if(searchTerm != str && !this.settings.multiple) { // Remove option icon from input if search is something else than a reset string
            this.element.find('.option-icon').remove();
          }
          var options = this.options;

          var originalText = this.optionsContent;

          options.each(function(i) {
            var reference = originalText[i];
            var matching = reference.match(new RegExp(searchTerm.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'), "gi")); // gi = Ignore font casing
            //Update selector for dropdown list when id is not available use this and use id selector when it is available default value for id is dd-opt followed by index number
            var selector = ($('#dd-opt'+i).length == 0) ? this : '#dd-opt' + i;

            if(matching != null) {
              // Let the automagic handle the searchterm matching
              searchTerm.replace(/(\s+)/,"(<[^>]+>)*$1(<[^>]+>)*");
              var pattern = new RegExp("("+searchTerm+")", "gi");
              var newContent = reference.replace(pattern, "<mark>$1</mark>");
              newContent = newContent.replace(/(<mark>[^<>]*)((<[^>]+>)+)([^<>]*<\/mark>)/,"$1</mark>$2<mark>$4");

              $(selector).find('.option-content').hide();
              if($(selector).find('.search-mode').length < 1) {
                $(selector).append('<span class="search-mode"></span>');
              }
              $(selector).find('.search-mode').html(newContent);
              $(selector).removeClass('opt-hidden').css('display', '');
            }
            else {
              $(selector).addClass('opt-hidden').css('display', 'none');
            }
          });

          // Either updating or clearing the screen reader live results based on if the dropdown is about to close
          if (this.searchResult) {
            if (isClosing === true) {
              this.searchResult.empty();
            } else {
              this.searchResult.text((options.length - options.filter('.opt-hidden').length) + this.searchResultText);
            }
          }

          if(options.filter('.opt-hidden').length < options.length){
           if(this.list.css('display') !== 'block') {
              this.list.css('display', 'block');
            }
          }
          else {
            this.list.css('display', 'none');
          }
        }
        else if(this.searchState === "on") {
          this.toggleBtn.find('.icon').attr('class', 'icon arrow down');
          this.toggleBtn.find('.icon use').attr('xlink:href', '#arrow');
          this.element.find('.search-mode').remove();
          this.element.find('.option-content').show();
          this.searchState = "off";
        }

        this.civicsSetPosition();
      },

      //-------------------------------------------------- searchMode function end -----------------------------------------------

      handleKeydown: function(key) { // Keyboard interaction
        this.list.find('.droppy-option').css('overflow', 'hidden');
        switch(key.which) {
          case 8:
          case 46: {
            if(this.settings.noSearch) {
              key.preventDefault();
              key.stopPropagation();
            }
            return;
          }
          case 38: // Up
          case 40: { // Down
            key.preventDefault();
            if(!this.isOpen()) {
              this.openList();
            }
            else {
              this.activateOption(key.which);
            }
            this.showActive();
            return;
          }
          case 32: // Space
          case 13: {  // Enter
            // stop active area from popping up from a tooltip activation
            if(key.target.className && key.target.className.indexOf("tooltip-trigger") != -1) {
              return;
            }
            if(this.list.find('.active-opt').length > 0) {
              key.preventDefault();
              if(!this.isOpen()) {
                this.openList();
              }
              else {
                this.selectOption($(this.list.find('.active-opt')[0]));
              }
            }
            return;
          }
          case 9: // Tab
          case 27: { // Esc
            // Track Shift+Tab to prevent auto-expand on focus
            if (key.which === 9 && key.shiftKey) {
              this._shiftTabbing = true;
            }
            this.closeList();
            return;
          }
        }
        // Don't open list on modifier keys (Shift, Ctrl, Alt, Meta, CapsLock)
        if (key.which === 16 || key.which === 17 || key.which === 18 || key.which === 20 || key.which === 91) {
          return;
        }
        if(!this.isOpen()) {
          this.openList();
        }
      },

      //-------------------------------------------------- keyDown function end -----------------------------------------------

      handleKeyup: function(key) { // Keyboard interaction
        // All of the below return statements is preventing search mode from being turned on.
        this.list.find('.droppy-option').css('overflow', 'hidden');
        switch(key.which) {
          case 8: { //Backspace
            if(this.settings.noSearch) {
              return;
            }
            if(this.input.val().length === 0) {
              this.searchMode(true, ""); // Reset the search list
              this.searchMode(false); // Exit search mode.
            }
            else {
              this.searchMode(true); //
            }
            return;
          }
          case 39:
          case 37: {
            return;
          }
          case 38: // Up
          case 40: { // Down
            return;
          }
          case 32: // Space
          case 13: {  // Enter
            if(this.searchState === "off") {
              return;
            }
            else {
              this.searchMode(true);
            }
          }
          case 45: // Insert
          case 46: // Del
          case 16: // Shift
          case 17: // Ctrl
          case 18: // Alt
          case 20: // CapsLock
          case 91: // Meta
          case 9: // Tab
          case 27: { // Esc
            return;
          }
        }
        if(!this.settings.noSearch) {
          this.searchMode(true);
        }
      },

      //-------------------------------------------------- keyUp function end -----------------------------------------------

      isOpen: function() {
        return this.list.is(':visible');
      },

      isDroppyElement: function(target) {
        return target.is(this.input) || target.is('.droppy-option') || target.is('.droppy-option *') || target.is(this.toggleBtn);
      },

      inputClick: function() {
        // Don't auto-expand if focus arrived via Shift+Tab
        if (this._shiftTabbing) {
          this._shiftTabbing = false;
          return;
        }
        if(!this.isOpen()) {
          this.openList();
        }
      },

      toggleBtnClick: function() {
        if(this.isOpen()) {
          this.closeList();
        }
        else {
          this.openList();
        }
      },

      closeList: function() {
        if(!this.isOpen() && this.searchState === 'off') {
          return;
        }
        if(this.inScrollableGrid){
          //append the options back into the droppy element for syphon purposes.
          this.input.parent().append(this.list);
        }

        this.searchMode(false, "", true); // Clear previous search with empty string if searchSate has been set to on previously.
        this.list.hide();

        if(this.settings.multiple) {
          this.setInputVal(this.selectedOptions.toString().replace(/,/g, ', ')); // Adding a space after comma.
          if(!this.settings.noSearch) {
            this.input[0].setSelectionRange(0, 0); // IE11 truncation fix.
          }
          this.list.find('.clone').remove();
          this.list.find('.group-label').hide();
          this.list.find('.active-opt').removeClass('active-opt');
        }
        else{
          this.setInputVal(this.selectedOptions[Object.keys(this.selectedOptions)[0]]);
          this.element.find('.option-icon').remove();

          if(this.selectedOptions[Object.keys(this.selectedOptions)[2]] != undefined) { // If a option with icon is selected, add the icon to input field.
            this.input.before(
              '<svg role="presentation" aria-hidden="true" class="option-icon '+this.selectedOptions[Object.keys(this.selectedOptions)[2]]+'">'+
                '<use xlink:href="'+this.selectedOptions[Object.keys(this.selectedOptions)[3]]+'"></use>'+
              '</svg>'
            )
          }
        }

        this.input.removeClass('input-top-widget');
        this.element.find('ul li').each(function(i) { // Remove aria id indexing, due to confliction with other droppys on the page.
          $(this).attr('id', '');
        });
        this.input.attr('aria-expanded', 'false');
        this.input.attr('aria-activedescendant', '');
        this.searchMode(false);
        // this.input.prop('readonly', 'readonly');

        this.input.trigger('droppyClose');
      },

      //-------------------------------------------------- closeList function end -----------------------------------------------

      civicsIsInViewport: function(el, list) {
        const rect = el.get(0).getBoundingClientRect();
        var customRect = {
          top: rect.top + list.height(),
          left: rect.right - 2,
          bottom: rect.top + list.height() + 2,
          right: rect.right
        };

        return (customRect.bottom <= (window.innerHeight || document.documentElement.clientHeight));
      },

      openList: function() {
        this.civicsOpenList();

        if(this.searchState === 'off') {
          this.list.show();
          this.input.focus();
          this.input.attr('aria-expanded', 'true');
          if(!this.settings.noSearch) {
            // this.input.prop('readonly', '');
            this.input.select();
          }
          this.showSelected();

           //when dropdown list are added on detail page the selector becomes $('#dropdownLists')
          //when accessing via out of the box fields it is accessible using this.element selector
          var droppyListSelector = (this.element.find('ul li').length != 0) ? this.element : $('#dropdownLists');

          droppyListSelector.find('ul li').each(function(i) {
            $(this).attr('id', 'dd-opt'+i+'');

            //remove opt-hidden class and display none style upon opening dropdown list
            //the style and class are added when using autocomplete
            //when search is turned off all the list option values should be visible
            $(this).removeClass('opt-hidden');
            $(this).prop('style').removeProperty('display');
          });

          if(!this.settings.multiple) {
            this.showActive();
          }
            // temporary fix for dropdowns in modals that cannot extend its width past a modal with vertical scroll
          var isModal = this.element.closest('.bbm-modal');

          //GET WIDTH OF LONGEST TEXT IN DROPDOWN LIST
          var optionContent = this.list.find(".option-content");
          var widthList = [];

          for (var i = 0; i < optionContent.length; i++) {
            widthList.push(optionContent[i].offsetWidth);
          }

          var maxTextWidth = Math.max.apply(null, widthList);
          if (maxTextWidth > this.input.outerWidth()) {
            this.list.find(".droppy-option").width(maxTextWidth);
          }
        }

        this.setDroppyWidth();

      },

      setDroppyWidth(isSetPosition){
        // temporary fix for dropdowns in modals that cannot extend its width past a modal with vertical scroll
        var isModal = this.element.closest('.bbm-modal');

        if(isModal.length > 0 && isModal[0].scrollHeight > isModal.height()){
          this.settings.extendListWidth = false;
        }

        if(this.settings.extendListWidth) {
          // Get top longest content in the list
          var filteredList = this.filterList(this.list.find(".option-content"));
            // Set the width of the dropdown list to increase if the content is too wide.
          var setWidth = this.getHiddenOffsetWidth(this.input.outerWidth(), filteredList);

          if(setWidth) {
            // Check width of largest element by width of window minus the list offset (with some padding) to prevent overflow
            let maxWidth = $(window).width() - this.list.offset().left;

            if(setWidth > maxWidth) {
              this.list.width(maxWidth);
            } else {
              this.list.css('width', '100%');
            }
          } else {
            this.list.css('width', '100%');
          }
        }
        // Adding open Upward functionality
        if(!this.civicsIsInViewport(this.input, this.list)) {
          this.list.addClass("openUp");
        } else {
          this.list.removeClass("openUp");
        }

        if(isSetPosition){
          this.civicsSetPosition();
        }
      },

      getHiddenOffsetWidth: function (inputWidth, list) {
        var highWidth = 0;
        list.each(function(i,e){
          // save a reference to a cloned element that can be measured
          var $hiddenElement = $(this).clone().appendTo('body');

          // calculate the width of the clone
          var width = $hiddenElement.outerWidth();

          // remove the clone from the DOM
          $hiddenElement.remove();

          highWidth = highWidth > width ? highWidth : width;
        });

        // Adding extra width to make sure there is enough space to show the text
        highWidth += this.settings.highWidthPadding;
        return inputWidth > highWidth ? false : highWidth;
      },

      filterList: function(list) {
        var longestContent = list.sort((a, b) => b.innerText.length - a.innerText.length);
        return longestContent.slice(0,15);
      },

      listClick: function(el) {
        this.selectOption(el);
      },

      setInputVal: function(val, $droppyList) {
        if ($droppyList !== undefined) {
          let droppyopt = $droppyList.find('.droppy-option[data-val="' + val + '"]');
          if ( droppyopt.length > 0) {
              // set all values to unselected, and select the new value in the dropdown
              $droppyList.find('.droppy-option').attr("aria-selected", "false").removeClass("pre-selected active-opt");
              droppyopt.attr("aria-selected", "true").addClass("pre-selected active-opt");
              this.input.val(droppyopt.text()).attr("title", droppyopt.text());
              this.input.data('currentSelection', val);
          }
        } else {
          this.input.val('');
          this.input.attr('title', val);
          this.input.val(val);
        }
      },

      activateOption: function(key) {
        var allOptions = this.list.find('li');
        var activeOption = allOptions.filter('.active-opt').index();
        var nowActive;

        if(key === 38) { // Up
          if(activeOption !== -1) { // If an option is selected, navigate active element from that index.
            allOptions.eq(activeOption).removeClass('active-opt'); // Deactivating previous option
            nowActive = allOptions.eq(activeOption -1);

            if(this.settings.multiple) { // If multi mode
              while(nowActive.is('.group-label, :hidden')) {
                nowActive = nowActive.prev();
              };
            }
            else { //Singleselect
              while(nowActive.is(':hidden')) {
                nowActive = nowActive.prev();
              }
            }
            nowActive.addClass('active-opt');

            this.input.attr('aria-activedescendant', 'dd-opt' + nowActive.index());
          }
        }

        if(key === 40) { // Down
          if(activeOption !== -1) { // If an option is selected, navigate active element from that index.
            allOptions.eq(activeOption).removeClass('active-opt');
            allOptions.eq(activeOption).attr('tabindex', '-1');
            nowActive = allOptions.eq(activeOption +1);
            if(this.settings.multiple) { // If multi mode
              while(nowActive.is('.group-label, :hidden')) {
                nowActive = nowActive.next();
              }
            }
            else { //Singleselect
              while(nowActive.is(':hidden')) {
                nowActive = nowActive.next();
              }
            }
            nowActive.addClass('active-opt');
            nowActive.attr('tabindex', '0')
            this.input.attr('aria-activedescendant', 'dd-opt' +nowActive.index());
          }
          else {
            allOptions.filter('.droppy-option').first().addClass('active-opt');
            this.input.attr('aria-activedescendant', allOptions.filter('.droppy-option').first().attr('id'));
          }
        }
      },

      //-------------------------------------------------- Activate function end -----------------------------------------------

      deactivateOption: function() {
        this.element.find('.active-opt').removeClass('active-opt');
        this.input.attr('aria-activedescendant', '');
      },

      selectOption: function(option, silent) {
        if(option.is('[disabled]')) {
          return;
        }
        if(this.searchState === "off" && (this.multiList.length < this.settings.maxSelected)) {
          this.setInputVal(""); // Reset the input
        }

        this.list.find('.droppy-option').removeClass('selected active-opt');
        this.list.find('.droppy-option:not(.multi-selected)').attr('aria-selected', false);
        $(option).addClass('active-opt');
        var optionContent = $(option).find('.option-content').text();
        var optionData = $(option).attr('data-val');
        var optionIcon = $(option).find('.icon').attr('class');
        var optionIconUse = $(option).find('use').attr('xlink:href');

        if(this.settings.multiple) {//Multieselect
          var dataValue = $(option).attr('data-val');
          var originalAndClone = this.list.find('[data-val='+dataValue+']'); // Object containing the original option and the clone.

          // If the option object already exist in the array, remove it.
          if($.grep(this.multiList, function(obj) { return obj.data == optionData; }).length > 0) {
            this.multiList = $.grep(this.multiList, function(e) {
              return e.data != optionData;
            });
            originalAndClone.removeClass('multi-selected');
            originalAndClone.find('.input-checkbox').prop('checked', false);
            originalAndClone.attr('aria-selected', false);
          }

          else {
            if(this.multiList.length == this.settings.maxSelected) {
              return;
            }
            originalAndClone.find('.input-checkbox').prop('checked', true);
            originalAndClone.addClass('multi-selected');
            originalAndClone.attr('aria-selected', true);
            this.multiList.push({
              content: optionContent,
              data: optionData
            });
          }

          this.selectedOptions = []; // Reset array of selected options
          var newSelection = this.selectedOptions;
          $.each(this.multiList, function(i, obj) {
            newSelection.push(obj.content);
          });
          this.selectedOptions = newSelection;
        }
        else {//Singleselect
          this.element.find('.option-icon').remove();
          $(option).attr('aria-selected', true);

          this.selectedOptions = {
            content: optionContent,
            data: optionData,
            icon: optionIcon,
            iconHref: optionIconUse,
          }
          if(optionIcon != undefined) {
            this.input.before(
              '<svg role="presentation" aria-hidden="true" class="option-icon '+this.selectedOptions[Object.keys(this.selectedOptions)[2]]+'">'+
                '<use xlink:href="'+this.selectedOptions[Object.keys(this.selectedOptions)[3]]+'"></use>'+
              '</svg>'
            )
          }
          this.setInputVal(optionContent);
        }
        if(this.searchState === "off" && this.settings.multiple) {
          this.setInputVal(this.selectedOptions.toString().replace(/,/g, ', '));
        }
        if (!silent) {
          this.element.trigger('droppyChange');
          this.input.focus();
        }
        if(this.settings.closeOnSelect) {
          this.closeList();
        }
      },

      //-------------------------------------------------- Select function end -----------------------------------------------

      showSelected: function() { // Scroll selected option into view.
        if(this.settings.multiple) {
          this.list.scrollTop(0);
          var selectGroup = this.list.find('.group-selected');
          var selectedOptions = this.list.find('.multi-selected').clone().addClass('clone').removeClass('multi-selected');

          if (selectedOptions.length > 0) {
            this.list.find('.group-label').css('display', 'block');
            selectedOptions.each(function() {
              selectGroup.after($(this).removeClass('active-opt'));
            });
          }
        }

        var selected = this.list.find('.selected');
        if (selected.length > 0) {
          this.list.scrollTop(0);
          this.list.scrollTop(selected.offset().top - this.list.offset().top - this.list.scrollTop() - 40);
        }
      },

      showActive: function() {
        var selected = this.list.find('.active-opt');
        if (selected.length > 0) {
          this.list.scrollTop(0);
          this.list.scrollTop(selected.offset().top - this.list.offset().top - this.list.scrollTop() - 80);
        }
      },

      clearError: function(input) {
        var $errDiv = input.closest('.droppy').siblings('.helper-msg-container, .error-msg').first();
        if ($errDiv) {
            $errDiv.closest('.field').removeClass('error');
            $errDiv.empty();
            $errDiv.hide();
        }
      },
    };

    // Initialize the plugin (Once)
    return this.each(function() {
      var instance = $.data(this, pluginName);
      if (instance) {
        instance.settings = $.extend({}, instance.settings, options);
      }
      else {
        instance = $.data(this, pluginName, new Droppy(this, settings));
      }
    });
  };

  /* start-amd-strip-block */
}));
/* end-amd-strip-block */
